import styled from 'styled-components'
import { SCREEN_SIZE, STYLES } from '../../static/style'

const TwoColumnFormView = styled.div`
  ${SCREEN_SIZE.SM} {
    ${({ isOneColumn }: { isOneColumn?: boolean }) =>
      !isOneColumn &&
      `
      display: flex;
      flex-wrap: wrap;
      & > * {
        width: 50%;
        box-sizing: border-box;
        &:nth-of-type(odd) {
          padding-right: calc(${STYLES.GUTTER} / 2);
        }
        &:nth-of-type(even) {
          padding-left: calc(${STYLES.GUTTER} / 2);
        }
      }
    `}
  }
`

export { TwoColumnFormView }
